import { USER_ROLES } from 'App';
import { UserContext } from 'contexts/UserContext';
import { get } from 'lib/comms';
import { useContext, useEffect, useState } from 'react';
import { Navigate } from 'react-router';

const NavigateComponent = (props) => {
    const [defaultRoute, setDefaultRoute] = useState('/');
    const { user } = useContext(UserContext);
    const fetchuserRoleIds = async (userId) => {
        const rolesResp = await get(`cms/user_roles/${userId}`, null, true);
        if (rolesResp && rolesResp.success) {
            const userRoleIds = rolesResp.user_roles;
            const isAdmin = userRoleIds.indexOf(USER_ROLES.ADMIN) !== -1;
            const isFinance = userRoleIds.indexOf(USER_ROLES.FINANCE) !== -1;
            const isManagement = userRoleIds.indexOf(USER_ROLES.MANAGEMENT) !== -1;
            const isUserMngmnt = userRoleIds.indexOf(USER_ROLES.USER_MANAGEMENT) !== -1;
            const isContent = userRoleIds.indexOf(USER_ROLES.CONTENT) !== -1;
            const defaultRoute =
                isAdmin || isManagement
                    ? '/dashboard'
                    : isUserMngmnt
                      ? '/users'
                      : isContent
                        ? '/micro'
                        : isFinance
                          ? '/billing'
                          : '/reports';
            setDefaultRoute(defaultRoute);
        }
    };

    useEffect(() => {
        fetchuserRoleIds(user.id);
    }, []);

    return (
        <Navigate
            to={{
                pathname: defaultRoute,
                state: { from: props.location },
            }}
        />
    );
};

export default NavigateComponent;
